<template>
  <div
    class="py-2 mx-1 rounded-lg focus:outline-none cursor-pointer"
    :class="[
      active
        ? 'text-brand-green border-2 border-brand-background-light-green bg-brand-background-light-green'
        : 'text-brand-gray border-2 border-brand-background-light-blue bg-white hover:bg-brand-background-blue-gray',
      isMobile ? 'px-1 text-sm' : 'px-2'
    ]"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
